module.exports = __webpack_public_path__ + "static/media/consumer.66b67301.png";